// eslint-disable-next-line
// @ts-ignore
import('./bootstrap');
